import React from 'react';
import styles from '../../styles/components/cards/BannerCard.module.css';

function BannerCard({ slot, banner, onEdit }) {
    const BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
    const hasData = !!banner && banner.image;

    const bannerImg = hasData 
        ? `${BASE_URL}/static/uploads/banners/${banner.image}` 
        : null;

    return (
        <div className={styles.card}>
            <div className={styles.header}>
                <div className={styles.slotInfo}>
                    <span className={styles.slotBadge}>Slot {slot}</span>
                    <h3 className={styles.cardTitle}>Banner de Destaque</h3>
                </div>
                <div className={`${styles.statusBadge} ${hasData ? styles.active : styles.inactive}`}>
                    {hasData ? 'Ativo' : 'Vazio'}
                </div>
            </div>

            <div className={styles.singlePreview}>
                <div className={styles.mediaBox}>
                    {bannerImg ? (
                        <img src={bannerImg} alt={`Banner Slot ${slot}`} className={styles.img} />
                    ) : (
                        <div className={styles.placeholder}>Imagem não configurada</div>
                    )}
                </div>
            </div>

            <div className={styles.footer}>
                <div className={styles.meta}>
                    <span className={styles.metaLabel}>Vínculo:</span>
                    <span className={styles.metaValue}>
                        {banner?.product_id ? `Produto ID: ${banner.product_id}` : 'Link Informativo'}
                    </span>
                </div>
                <button className={styles.editButton} onClick={onEdit}>
                    {hasData ? 'Editar Banner' : 'Configurar Slot'}
                </button>
            </div>
        </div>
    );
}

export default BannerCard;